module.exports = "a:hover, a:focus, a:active, a:visited {\n  /* color: #8bb767; */\n  text-decoration: underline;\n  color: #5b5b5b; }\n\na {\n  color: #5b5b5b; }\n\n.txtwarp {\n  overflow: hidden;\n  display: inline-block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100% !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/sub-component/kitchen/kitchen-attach-browse/kitchen-attach-browse.component.scss
// module id = ./src/app/seller/sub-component/kitchen/kitchen-attach-browse/kitchen-attach-browse.component.scss
// module chunks = main